import { render, staticRenderFns } from "./add-new-car.vue?vue&type=template&id=5b5567f6"
import script from "./add-new-car.vue?vue&type=script&lang=js"
export * from "./add-new-car.vue?vue&type=script&lang=js"
import style0 from "./add-new-car.vue?vue&type=style&index=0&id=5b5567f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports